import { withNamespace } from "@/i18n/lazy-route"

/** Staff administration of accounts (LLD §9.15, Task 2.3), with the `adminUsers` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminUsers.json"),
  fr: () => import("@/i18n/locales/fr/adminUsers.json"),
}

export const UserListScreen = withNamespace(
  "adminUsers",
  () => import("./screens/UserListScreen"),
  translations,
)
export const UserDetailScreen = withNamespace(
  "adminUsers",
  () => import("./screens/UserDetailScreen"),
  translations,
)
